import "./User.css";
import { Link } from 'react-router-dom';
const User =(props)=>{
    // console.log(props);
    return(
            <div className="user-box">
                <div className="user-info">
                </div>
                <div className="user-settings">
                    <ul className="user-details">
                        <li className="user_id"><strong>User Id:</strong> {props.user.userName}</li>
                        <li className="email"><strong>Email:</strong> {props.user.emailId}</li>
                        {/* <li className="adress">Address : {props.user.address}</li> */}
                    </ul>
                </div>
            </div>
    );
}
export default User;